import React, { useEffect, useState } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import "./Scan.css";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";  // Import your configured axios instance
import useAuth from "../../hooks/useAuth";
import TopBar from "./TopBar";
import { useNavigate, Link } from "react-router-dom";
import { formatDate } from "../../utils/Utilities.js";

const ManifestOutScan = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/ManifestInScan");
  }
  const handleRedirect2 = () => {
    navigate("/ListManifestOutScanByDate");
  }
  // State to store form data and API response message
  const { auth } = useAuth();
  const [manifestMumber, setManifestNumber] = useState("");

  const [responseMessage, setResponseMessage] = useState("");
  const [trackingId, setTrackingId] = useState("");  // New state for tracking ID
  const axiosPrivate = useAxiosPrivate();
  const MANIFEST_OUT_URL = "/api/manifest-outscan"; // Replace with the correct API endpoint to fetch users


  const [manifestOutScan, setManifestOutScan] = useState([]);
  const [loading, setLoading] = useState(false); // Set loading initially to false
  const [error, setError] = useState(null); // To handle errors
  const LIST_MANIFEST_OUTSCAN_URL = "api/list-manifest-outscan";

  const fetchManifestOutScan = async () => {
    setLoading(true);
    try {
      const today = new Date();
      const fromDateFormatted = formatDate(today);
      const toDateFormatted = formatDate(today);

      const data = {
        franchise_id: auth.franchise_id,
        from_date: fromDateFormatted,
        to_date: toDateFormatted,
      };

      const response = await axiosPrivate.get(LIST_MANIFEST_OUTSCAN_URL, {
        params: data,
      });

      setManifestOutScan(response.data);
      setError(null);
    } catch (error) {
      console.error("Error fetching Bookings Consignments:", error);
      setError("Failed to load Booking Consignments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchManifestOutScan();
  }, []);










  const postinscan = async () => {
    try {
      const data = {
        manifest_number: manifestMumber,
        franchise_id: auth.franchise_id,
      };
      const response = await axiosPrivate.post(MANIFEST_OUT_URL, data);
      console.log(response.data);

      // Check if both message and tracking_id are available
      setResponseMessage(response.data.message || "Success");
      setTrackingId(response.data.tracking_id || ""); // Set tracking_id if available
    } catch (error) {
      if (error.response) {
        // If there is an error response from the server
        console.error("Error:", error.response.data.message);
        setResponseMessage(error.response.data.message || "An error occurred on the server.");
        setTrackingId("");  // Clear tracking_id on error
      } else {
        // If there is no error response (network error, etc.)
        console.error("Error:", error.message);
        setResponseMessage("An unexpected error occurred.");
        setTrackingId("");  // Clear tracking_id on network error
      }
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent page reload on form submit
    await postinscan();
    await fetchManifestOutScan();
  };

  return (
    <>
      <section className="inscanbody">
        <br />

        <div className="wrapper4">
          <div className="d-flex align-items-center">
            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
            <div className="d-flex gap-2 ms-auto">
              <button onClick={handleRedirect2} type="button" className="btn btn-success top-bt">
                Manifest OutScan List
              </button>
              <button onClick={handleRedirect} type="button" className="btn btn-success top-bt">
                Manifest In Scan
              </button>
            </div>
          </div>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">Manifest In Scan</button> */}
          <form onSubmit={handleSubmit}>
            <h3>Manifest Out Scan</h3>
            <Row>
              <Col></Col>
              <Col>
                <center><div className="input-boxs">
                  <label htmlFor="manifest_number">Manifest Number  </label>
                  <input
                    type="text"
                    id="manifest_number"
                    placeholder=""
                    value={manifestMumber}
                    onChange={(e) => setManifestNumber(e.target.value)}
                    required
                  />
                </div></center>

                <center><button type="submit" className="btn scanbutton">
                  Submit
                </button></center>
              </Col>
              <Col></Col>
            </Row>


          </form>

          {/* Display response message */}
          {responseMessage && (
            <div className="response-message">
              <p>
                {responseMessage && (
                  <span>{`Message: ${responseMessage}`}</span>
                )}
                {trackingId && (
                  <span>{` Tracking ID: ${trackingId}`}</span>
                )}
              </p>
            </div>
          )}

          <div>
            {loading && <p>Loading...</p>}
            {error && <p>{error}</p>}

            {!loading && !error && manifestOutScan.length > 0 && (
              <table>
                <thead>
                  <tr>
                    <th>Manifest number</th>
                    <th>Manifest date</th>
                    <th>Destination franchise</th>
                    <th>Total cons.</th>
                    <th>Weight</th>
                    <th>scan time</th>
                    <th>Current status</th>
                  </tr>
                </thead>
                <tbody>
                  {manifestOutScan.map((booking, index) => (
                    <tr key={index}>
                      <td>{booking.manifest_number}</td>
                      <td>{booking.manifest_date}</td>
                      <td>{booking.manifest_destination_franchise_name} -
                        {booking.manifest_destination_franchise_code}
                      </td>
                      <td>{booking.total_consignments}</td>
                      <td>{booking.weight}</td>
                      <td>{booking.scan_time}</td>
                      <td>{booking.current_status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {!loading && !error && manifestOutScan.length === 0 && (
              <p>No bookings found</p>
            )}
          </div>

        </div>
      </section>
      <TopBar />
    </>
  );
};

export default ManifestOutScan;
